import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import hjelp from '../../assets/images/help.svg';
import poweroff from '../../assets/images/poweroff.svg';
import profil from '../../assets/images/profil.svg';
import Utils from '../../felles/Utils';
import C from '../../assets/styles/UtilsCSS';
import UserCred from '../../models/UserCred';
import * as actions from '../../store/actions/index';
import { AppState } from '../../store/rootReducer';
import { useNavigate } from 'react-router-dom';

// Define styles
const useStyles = makeStyles()(() => ({
  root: {
    background: 'linear-gradient(to right, rgba(219, 219, 219, 0) 0%, rgba(219, 219, 219, 1) 10%)',
    display: 'flex',
    justifyContent: 'flex-end', // Align children to the right
    width: '300px',
    marginTop: 8,
    marginRight: -5,
    [C.IPAD_10]: { marginTop: 6, width: '100%' },
    [C.SAMSUNG]: { width: '100%' },
  },
  child: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '7px', // Reduce padding for less space
    marginLeft: '0', // Remove auto margin to avoid pushing elements

    cursor: 'pointer',
    fontWeight: 400,
  },
  childLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '7px', // Reduce padding for less space
    // Remove auto margin to avoid pushing elements
    cursor: 'pointer',
    fontWeight: 400,
  },
  subchild: { paddingTop: '1px', paddingLeft: '4px', },
}));

export default function LPNavigationProfile() {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Use typed state from AppState
  const user = useSelector((state: AppState) => state.auth.userJWT);
  const isAlreadyLoggedFromAnotherTab = useSelector(
    (state: AppState) => state.auth.isAlreadyLoggedFromAnotherTab
  );
  const tabListSize = useSelector((state: AppState) => state.auth.tabListSize);

  // UseCallback for performance optimization
  const handleLogoutClicked = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
      event.preventDefault();
      // update the state
      dispatch(actions.setIsLogged(0));
      dispatch(actions.setTabAsActive(true));
      // Logout - always show login form since all tabs/windows will log out
      const loginStateUI = -1;
      dispatch(
        actions.UserLogoutFetchValidation(
          new UserCred('BAD', 'BAD', '', false),
          false,
          0,
          loginStateUI, //loginStateUI
          isAlreadyLoggedFromAnotherTab,
          tabListSize,
          true // activeTab
        )
      );
    },
    [dispatch, isAlreadyLoggedFromAnotherTab, tabListSize]
  );
  //
  const handleProfileClickHandler = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.preventDefault();
     navigate(`${Utils.HOMEPAGE_CONTEXT}/BR04`);
    },
    []
  );


  const handleHjelpClickHandler = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.preventDefault();
      const newWindow = window.open('https://www.vitec-autosystemer.com/dokumentasjon-autodata/', '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    },
    []
  );

  //
  return (
    <div className={classes.root}>
      <div className={classes.child} onClick={handleHjelpClickHandler}>
        <img src={hjelp} alt="Hjelp" />
        &nbsp;Hjelp
      </div>
      <div
        className={classes.child}
        onClick={handleProfileClickHandler}
        style={{ lineHeight: 1 }}
      >
        <img src={profil} alt="Profile" />
        <div className={classes.subchild}>{user?.cn}</div>
      </div>
      <div className={classes.childLeft} onClick={handleLogoutClicked}>
        <img src={poweroff} alt="Logout" />
        &nbsp;Logg&nbsp;ut
      </div>
    </div>
  );
}